<template>
	<div class="incomeAll">
		<h6>编辑个人资料</h6>
		<section class="info ">
			<form action="">
				<ul>
					<li class="flex zhong">
						<label>头像：</label>
						<div class="regsit_div">
							<div class="info_photo">
								<img :src="userInfo.ImgStr || require('../../image/p-head.png')" @click.stop="uploadHeadImg" />
								<input type="file" accept="image/jpeg,image/jpg,image/png,image/svg" @change="handleFile" class="hiddenInput" />
							</div>
						</div>
					</li>
					<li class="flex zhong">
						<label>
							<span>*</span>
							用户ID：
						</label>
						<div class="regsit_div">
							<label>{{ userInfo.Number }}</label>
						</div>
					</li>
					<li class="zhong  flex">
						<label>
							<span>*</span>
							考生姓名：
						</label>
						<div class="regsit_div">
							<div class="login_input flex zhong "><input type="text" v-model="userInfo.Name"  :disabled="isdisabled"/></div>
						</div>
					</li>
					<li class="zhong  flex">
						<label>
							<span>*</span>
							考生性别：
						</label>
						<div class="regsit_div flex">
							<div class="regsit_radio flex zhong">
								<div class="flex pt_li" @click="setGender(1)">
									<!-- <input type="radio" name="sex" /> -->
									<img :src="userInfo.Gender == 1 ? require('../../image/Eva-aa.png') : require('../../image/Eva-a.png')" />
									<label style="margin-left: 10px;">男</label>
								</div>
								<div class="flex pt_li" @click="setGender(2)">
									<!-- <input type="radio" name="sex" /> -->
									<img :src="userInfo.Gender == 2 ? require('../../image/Eva-aa.png') : require('../../image/Eva-a.png')" />
									<label style="margin-left: 10px;">女</label>
								</div>

								<!-- 2.22 -->
								<!-- <label>{{ userInfo.Gender | gender }}</label> -->
							</div>
						</div>
					</li>
					<li class="zhong  flex">
						<label>
							<span>*</span>
							考生类型：
						</label>
						<div class="regsit_div flex">
							<div class="regsit_radio flex">
								<!-- 学生类型 1文科 2 理科 3 不分文理 -->
								<div class="flex pt_li" @click="setType(1)">
									<img :src="userInfo.Type == 1 ? require('../../image/Eva-aa.png') : require('../../image/Eva-a.png')" />
									<!-- <input :checked="userInfo.Type==1" type="radio" /> -->
									<label style="margin-left: 10px;">文科或选历史</label>
								</div>
								<div class="flex pt_li" @click="setType(2)">
									<!-- <input type="radio" /> -->
									<img :src="userInfo.Type == 2 ? require('../../image/Eva-aa.png') : require('../../image/Eva-a.png')" />
									<label style="margin-left: 10px;">理科或选物理</label>
								</div>
								<div class="flex pt_li" @click="setType(3)">
									<!-- <input type="radio" /> -->
									<img :src="userInfo.Type == 3 ? require('../../image/Eva-aa.png') : require('../../image/Eva-a.png')" />
									<label style="margin-left: 10px;">文理不分科</label>
								</div>
								<!-- 2.22 -->
								<!-- <label>{{ userInfo.Type | userType }}</label> -->
							</div>
						</div>
					</li>
					<li class="zhong  flex">
						<label>
							<span>*</span>
							高考年份：
						</label>
						<div class="regsit_div">
							<!-- <div class="login_input flex zhong "><input type="text" v-model="userInfo.CollegeYear" :disabled="isdisabled" />年</div> -->
							
							<el-select v-model="userInfo.CollegeYear" placeholder="选择高考年份" class="years" style="width: 320px;">
								<el-option v-for="item in yearArr" :key="item" :label="item + '年'" :value="item"></el-option>
							</el-select>
						</div>
					</li>
					<li class="zhong  flex">
						<label>
							<span>*</span>
							所在地：
						</label>
						<div class="regsit_div">
							<area-cascader :level="1" placeholder="请选择地区" v-model="selected" :data="pcaa" @change="setAreaCascader" :disabled="isdisabled" ></area-cascader>

							<!--
                            2.22
                            <div class="login_input flex zhong ">
                                 <input type="text" :value="userInfo.FullCityName" disabled />
                            </div> -->
						</div>
					</li>
					<li class="zhong  flex">
						<label>
							<!-- <span>*</span> -->
							学校：
						</label>
						<div class="regsit_div">
							<!--
                            2.22
                            <div class="login_input flex zhong ">
                                <input type="text" :value="userInfo.School" disabled />
                            </div> -->
							<el-select v-model="userInfo.School" placeholder="请选择" style="width: 300px;" :disabled="isdisabled">
								<el-option v-for="item in options" :key="item" :label="item" :value="item"></el-option>
							</el-select>
						</div>
					</li>

					<li class="zhong  flex">
						<label>我的规划师：</label>
						<div class="regsit_div">
							<el-select v-model="userInfo.TeacherId" clearable placeholder="选择规划师" style="width: 300px;" :disabled="isdisabled">
								<el-option v-for="item in optionsb" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
							</el-select>
						</div>
					</li>
					<li class="zhong  flex">
						<label></label>
						<div class="regsit_div">
							<p>
								所填信息与系统使用数据相关联，且带“*”号资料设置后不可修改！请务必填写真实信息。注意：考生类型：上海、浙江、北京、天津、山东、海南选择“文理不分科”；河北、辽宁、江苏、福建、湖北、湖南、广东、重庆选择“选历史”或“选物理”
							</p>
						</div>
					</li>
					<li class="zhong  flex" v-if="!isdisabled">
						<label></label>
						<div class="regsit_div"><el-button type="primary" class="btn" @click="submitClick()">保存</el-button></div>
					</li>
				</ul>
			</form>
		</section>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { uploadPicture } from '../../utils/upload';
import 'vue-area-linkage/dist/index.css';
import { pca, pcaa } from 'area-data';
export default {
	data() {
		return {
			region: '',
			school: '',
			isBtn: true, // 是否编辑跳过来的
			userInfo: null,
			isdisabled: false, // 是否禁用
			pca: pca,
			pcaa: pcaa,
			yearArr:[],
			selected: [],
			// 2022.2.22
			options: [],
			value: '',
			optionsb: [],
			valueb: '',
			isCke: false
		};
	},
	computed: {
		...mapState(['user'])
	},
	created() {
		this.userInfo = {
			...this.user.user
		};
		if (this.userInfo) {
			console.log('用户', this.userInfo);
			if(this.userInfo&&this.userInfo.CityCode){
				this.selected[0] = this.userInfo.CityCode.substring(0, 2) + '0000';
				this.selected[1] = this.userInfo.CityCode.substring(0, 4) + '00';
				this.selected[2] = this.userInfo.CityCode;
				this.$api.getSchoolByArea({ code: this.userInfo.CityCode }).then(res => {
					this.options = res.data;
				});
			}
			
			if (this.userInfo.Name) {
				this.isdisabled = true;
			}
			this.userInfo.TeacherId = this.userInfo.TeacherId?this.userInfo.TeacherId:'';
		}
		this.yearArr = [];
		const startYear = new Date().getFullYear();
		for (let i = 0; i < 21; i++) {
			const year = startYear + i + '';
			this.yearArr.push(year);
		}
		this.getPlaner();
		this.GetUserInfo();
	},
	methods: {
		// 获取用户信息
		GetUserInfo: function() {
			var that = this;
			that.$api.HtppRequest(
				'User',
				'GET', {},
				function(res) {
					console.log('获取用户信息');
					console.log(res);
					if (res.code === 0) {
						that.userInfo = res.data;
						if (that.userInfo.Name) {
							that.isdisabled = true;
						}
						// that.$store.dispatch('user/setUser', null);
						that.$store.dispatch('user/setUser', that.userInfo);
					}
					that.GetDetail();
				},
				function(res) {}
			);
		},
		getPlaner() {
			var that = this;
			that.$api.HtppRequest(
				'user/Planer',
				'GET',
				{},
				function(res) {
					if (res.code === 0) {
						that.optionsb = res.data;
						console.log('optionsb', that.optionsb);
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		submitClick() {
			var that = this;
			console.log('保存');
			if (that.isCke) {
				return;
			}
			// if (!this.userInfo.Img) {
			// 	this.$util.showError('请上传头像');
			// 	return;
			// }
			if (!that.userInfo.Name) {
				that.$util.showError('请输入考生姓名');
				console.log(that.userInfo);
				return;
			}
			if (!that.userInfo.CityCode) {
				that.$util.showError('请选择所在地');
				return;
			}
			// if (!this.userInfo.School) {
			// 	this.$util.showError('请输入学校');
			// 	return;
			// }
			that.isCke = true;
			that.$api.HtppRequest(
				'user/UpdateUser',
				'POST',
				{
					Id: that.userInfo.Id,
					Name: that.userInfo.Name,
					Img: that.userInfo.Img,
					Gender: that.userInfo.Gender,
					Type: that.userInfo.Type,
					CollegeYear: that.userInfo.CollegeYear,
					CityCode: that.userInfo.CityCode,
					School: that.userInfo.School,
					TeacherId: that.userInfo.TeacherId?that.userInfo.TeacherId:0
				},
				function(res) {
					if (res.code === 0) {
						that.$util.showOk('保存成功');
						// that.$store.dispatch('user/setUser', null);
						that.$store.dispatch('user/setUser', that.userInfo);
						that.isdisabled = true;
					}
					that.isCke = false;
				},
				function(err) {
					console.log(err);
					that.isCke = false;
				}
			);
		},
		setAreaCascader() {
			var that = this;
			that.options = [];
			console.log('地址', that.selected);
			this.userInfo.CityCode = that.selected[2];
			that.$api.getSchoolByArea({ code: that.selected[2] }).then(res => {
				that.options = res.data;
				console.log('options', that.options);
				if (that.options.length > 0) {
					var isy = false;
					that.options.map(a => {
						if (a === that.userInfo.School) {
							isy = true;
						}
					});
					if (!isy) {
						that.userInfo.School = '';
					}
				}
			});
		},
		setGender(type) {
			if (!this.isdisabled) {
				this.userInfo.Gender = type;
			}
		},
		setType(type) {
			if (!this.isdisabled) {
				this.userInfo.Type = type;
			}
		},
		// 打开图片上传
		uploadHeadImg() {
			this.$el.querySelector('.hiddenInput').click();
		},
		// 将头像显示
		handleFile(e) {
			const $target = e.target || e.srcElement;
			const file = $target.files[0];
			uploadPicture(file)
				.then(res => {
					this.userInfo.ImgStr = res.url;
					this.userInfo.Img = res.id;
					return this.$api.updateUserAvatar(res.id);
				})
				.then(res => {
					this.$util.showOk('保存成功');
					this.$store.dispatch('user/setUser', this.userInfo);
				});
		}
	}
};
</script>

<style scoped>
/deep/.area-select.large {
	width: 300px;
	height: 40px;
	line-height: 40px;
	border: solid 1px #e6e6e6;
}

/deep/.selected {
	color: #005371 !important;
}

/deep/.area-selected-trigger {
	padding-top: 0 !important;
}

.regsit_div {
	overflow: visible !important;
}

.pt_li {
	width: 120px;
}

.pt_li label {
	line-height: 18px;
}

* >>> .area-select.medium {
	margin-left: 0;
	height: 40px;
	line-height: 40px;
	margin-right: 10px;
}

* >>> .area-selectable-list .area-select-option.selected {
	color: #333;
}

* >>> .area-select.medium span {
	padding-top: 0;
	padding-bottom: 0;
}

* >>> .area-select-wrap {
	display: flex;
}

.info_photo input {
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 10;
	cursor: pointer;
	opacity: 0;
}

.btn {
	width: 300px;
}

.regsit_radio {
	margin-right: 3em;
}

.regsit_radio label {
	margin-left: 10px;
	width: auto !important;
	color: #999 !important;
}

.login_input input::-webkit-input-placeholder,
* >>> .el-input__inner::-webkit-input-placeholder {
	color: #999;
}

.login_input input:-moz-placeholder,
* >>> .el-input__inner::-moz-placeholder {
	color: #999;
}

.login_input input:-ms-input-placeholder,
* >>> .el-input__inner::-ms-input-placeholder {
	color: #999;
}

.login_input input {
	overflow: hidden;
	width: calc(100% - 30px);
	padding-left: 10px;
	font-size: 14px;
	color: #999;
	display: block;
	height: 100%;
	position: relative;
}

.login_input img {
	display: block;
	width: 20px;
	height: 20px;
}

.login_input {
	margin-bottom: 20px;
	overflow: hidden;
	border-radius: 4px;
	height: 40px;
	border: solid 1px #e6e6e6;
	padding: 0 10px;
	width: 100%;
	box-sizing: border-box;
}

.info_div label {
	text-indent: 15px;
	width: auto !important;
	text-align: left !important;
}

.info_photo img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.info_photo {
	margin-left: 95px;
	overflow: hidden;
	width: 100px;
	height: 100px;
	border-radius: 50px;
	position: relative;
	background: url(../../image/p-head.png) no-repeat left top;
	background-size: 100% 100%;
}

.info {
	overflow: visible !important;
}

.regsit_div p {
	background-color: #fceceb;
	border-radius: 4px;
	height: auto;
	padding: 10px;
	box-sizing: border-box;
	text-indent: 20px;
	font-size: 14px;
	color: #de443b;
}

.regsit_div {
	overflow: hidden;
	width: 460px;
	margin-left: 10px;
}

.years {
	width: 300px;
}

.regsit_div .login_input {
	width: 300px;
	margin-bottom: 0;
}

.regsit_div {
	overflow: hidden;
	width: 460px;
	margin-left: 20px;
}

.info label span {
	color: #e05750;
}

.info label {
	font-size: 14px;
	color: #333;
	width: 88px;
	text-align: right;
	display: block;
}

.info ul li {
	margin-bottom: 20px;
}

.info {
	overflow: hidden;
	padding-top: 35px;
	padding-left: 100px;
}

.incomeAll > h6 {
	border-bottom: solid 1px #e6e6e6;
	font-size: 16px;
	color: #333;
	height: 62px;
	line-height: 62px;
	text-indent: 20px;
	position: relative;
}

.incomeAll > h6::after {
	content: '';
	width: 100px;
	height: 2px;
	background-color: #333;
	position: absolute;
	left: 20px;
	bottom: 0;
	z-index: 0;
}
</style>
